import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Text } from "braid-design-system";
import omit from "lodash/omit.js";
import { translations } from "../../../EmployerFooter/GeneralLinks/.vocab/index.mjs";
import { needHelpLink } from "../EmployerFooter.css.mjs";
const NeedHelpLink = ({
  href,
  label,
  linkRenderer: LinkRenderer,
  ...restProps
}) => {
  const { t } = useTranslations(translations);
  const HelpCentreLink = () => /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      href,
      className: needHelpLink,
      ...omit(restProps, ["specificSite"]),
      children: label
    }
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: ["block", "inline"],
      paddingTop: ["small", "none"],
      paddingBottom: ["medium", "xsmall"],
      children: /* @__PURE__ */ jsx(Text, { size: "small", weight: "medium", children: t("Help Centre message", {
        HelpCentreLink: () => /* @__PURE__ */ jsx(HelpCentreLink, {}, label)
      }) })
    }
  );
};
export {
  NeedHelpLink
};
